export const safeLogError = (error) => {
    var _a;
    if (process.env.NEXT_PUBLIC_ZAPIER_ORIGIN &&
        !((_a = process.env.NEXT_PUBLIC_ZAPIER_ORIGIN) === null || _a === void 0 ? void 0 : _a.includes('zapier.com')) &&
        error) {
        console.error(error);
    }
};
//# sourceMappingURL=safeLogError.js.map